import inventory from '@/api/inventory-list'
import branch from '@/api/branch'
import location from '@/api/warehouse'
import moment from 'moment'
import { mapKeys, camelCase } from 'lodash'
import { baseState, baseMutations } from '@/store/mixins'

class Pagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export const state = {
  ...baseState,
  branch_id: null,
  location_id: null,
  date_from: moment().startOf('M').format('DD-MM-YYYY'),
  date_to: moment().endOf('M').format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_RESOURCES(state, records) {
    const { data, ...meta } = records
    state.resources = data
    state.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
  },
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_BRANCH_ID(state, branch_id) {
    state.branch_id = branch_id
  },
  SET_LOCATION_ID(state, location_id) {
    state.location_id = location_id
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        branch_id: context.state.branch_id,
        location_id: context.state.location_id
      },
      attrubutes
    )
    return inventory.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response.data)
    })
  },
  store(context) {
    return inventory.store({
      search: context.state.search,
      date_from: context.state.date_from,
      date_to: context.state.date_to,
      branch_id: context.state.branch_id,
      location_id: context.state.location_id
    })
  },
  getBranch(context, attributes = {}) {
    return branch.get({
      params: {
        fields: {
          setup_branch_profiles: 'branch_id,branch_name_en'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getLocation(context, attributes = {}) {
    return location.get({
      params: attributes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
